import React, { useState, useEffect } from 'react';
import PipelineBoard from './PipelineBoard';
import KpiWidget from './KpiWidget';
import { useAuth } from './AuthContext';
import './css/PipelineDashboard.css';
import './css/BaobabDesignSystem.css';

const PipelineDashboard = () => {
  const [activeView, setActiveView] = useState('board'); // Démarrer en vue Kanban
  const [showKpis, setShowKpis] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  
  const { user } = useAuth();

  // Gestion du plein écran
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  return (
    <div className={`pipeline-dashboard ${isFullscreen ? 'fullscreen' : ''}`}>
      {/* Header with Controls */}
      <div className="pipeline-dashboard-header">
        <div className="dashboard-title-section">
          <h1 className="dashboard-title">
            🚀 Pipeline Commercial KPIs
          </h1>
          <p className="dashboard-subtitle">
            Visualisez, automatisez et analysez votre pipeline de ventes
          </p>
        </div>
        
        <div className="dashboard-controls">
          {/* View Toggle */}
          <div className="view-toggle">
            <button
              className={`toggle-btn ${activeView === 'board' ? 'active' : ''}`}
              onClick={() => setActiveView('board')}
              title="Vue Kanban"
            >
              📋 Kanban
            </button>
            <button
              className={`toggle-btn ${activeView === 'kpis' ? 'active' : ''}`}
              onClick={() => setActiveView('kpis')}
              title="Tableau KPIs"
            >
              📊 KPIs
            </button>
          </div>

          {/* Additional Controls */}
          <div className="additional-controls">
            <button
              className="control-btn"
              onClick={() => setShowKpis(!showKpis)}
              title="Afficher/Masquer KPIs"
            >
              {showKpis ? '🙈' : '🙉'} KPIs
            </button>
            
            <button
              className="control-btn"
              onClick={toggleFullscreen}
              title="Plein écran"
            >
              {isFullscreen ? '🗗' : '🗖'} 
            </button>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="pipeline-dashboard-content">
        {/* Pipeline Board Section */}
        {activeView === 'board' && (
          <div className="pipeline-board-section">
            <PipelineBoard />
          </div>
        )}

        {/* Pure KPIs View - All KPIs for dedicated KPIs view */}
        {activeView === 'kpis' && (
          <div className="pure-kpis-view">
            
            {/* KPIs Widgets pour la vue pure KPIs */}
            <div className="kpi-grid">
              {/* Row 1 - Core Metrics */}
              <KpiWidget type="pipeline_total" refreshInterval={30000} />
              <KpiWidget type="win_rate" refreshInterval={60000} />
              <KpiWidget type="cycle_time" refreshInterval={60000} />
              
              {/* Row 2 - Analysis Metrics */}
              <KpiWidget type="forecast" refreshInterval={30000} />
              <KpiWidget type="conversion_stages" refreshInterval={300000} />
              <KpiWidget type="stage_distribution" refreshInterval={300000} />
              
              {/* Row 3 - New Advanced KPIs */}
              <KpiWidget type="monthly_performance" refreshInterval={300000} />
              <KpiWidget type="commercial_ranking" refreshInterval={300000} />
              <KpiWidget type="pipeline_velocity" refreshInterval={300000} />
              
              {/* Row 4 - Trends & Insights */}
              <KpiWidget type="opportunities_trend" refreshInterval={300000} />
              <KpiWidget type="client_acquisition" refreshInterval={300000} />
              <KpiWidget type="revenue_projection" refreshInterval={300000} />
            </div>
          </div>
        )}
      </div>

      {/* Footer Info */}
      {!isFullscreen && (
        <div className="pipeline-dashboard-footer">
          <div className="footer-info">
            <span className="last-update">
              Dernière mise à jour: {new Date().toLocaleString('fr-FR')}
            </span>
            <span className="user-info">
              Utilisateur: {user?.full_name || user?.username}
            </span>
          </div>
          
          <div className="footer-legend">
            <div className="legend-item">
              <span className="legend-color" style={{ backgroundColor: '#22C55E' }}></span>
              <span>Excellent</span>
            </div>
            <div className="legend-item">
              <span className="legend-color" style={{ backgroundColor: '#F59E0B' }}></span>
              <span>Attention</span>
            </div>
            <div className="legend-item">
              <span className="legend-color" style={{ backgroundColor: '#EF4444' }}></span>
              <span>Critique</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PipelineDashboard;